// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Yj1R","tab":"ProcedureTabs_tab__2ILi5"};